import React from 'react';
import { Bell, X, CheckCircle2, Info } from 'lucide-react';

const NotificationCenter = ({ notifications, onClose, onNavigate, onMarkAsRead, onMarkAllRead }) => {
  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <div className="absolute top-14 right-0 w-80 md:w-96 bg-white rounded-2xl shadow-2xl border border-slate-100 overflow-hidden z-50 animate-in fade-in zoom-in-95 origin-top-right">
      <div className="p-4 border-b border-slate-50 bg-white flex justify-between items-center">
        <div className="flex items-center gap-2">
          <h4 className="font-bold text-slate-800">Notifications</h4>
          {unreadCount > 0 && (
            <span className="bg-red-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full">
              {unreadCount}
            </span>
          )}
        </div>
        <div className="flex gap-2">
          {unreadCount > 0 && (
            <button
              onClick={onMarkAllRead}
              className="text-[10px] font-bold text-blue-600 hover:bg-blue-50 px-2 py-1 rounded transition"
            >
              Tout lire
            </button>
          )}
          <button
            onClick={onClose}
            className="text-slate-400 hover:bg-slate-100 p-1 rounded-full transition"
          >
            <X size={16} />
          </button>
        </div>
      </div>

      <div className="max-h-[400px] overflow-y-auto scrollbar-hide">
        {notifications.length === 0 ? (
          <div className="p-12 text-center flex flex-col items-center text-slate-400">
            <div className="w-12 h-12 bg-slate-50 rounded-full flex items-center justify-center mb-3">
              <Bell size={20} className="opacity-50" />
            </div>
            <p className="text-sm">Aucune notification.</p>
          </div>
        ) : (
          notifications.map(n => (
            <div
              key={n.id}
              onClick={() => {
                onMarkAsRead(n.id);
                if (n.target) {
                  onNavigate(n.target);
                  onClose();
                }
              }}
              className={`p-4 border-b border-slate-50 hover:bg-slate-50 cursor-pointer transition flex gap-3 items-start group ${!n.read ? 'bg-blue-50/40' : ''}`}
            >
              <div className={`mt-1 w-8 h-8 rounded-full flex items-center justify-center shrink-0 ${n.type === 'success' ? 'bg-green-100 text-green-600' : 'bg-blue-100 text-blue-600'}`}>
                {n.type === 'success' ? <CheckCircle2 size={14} /> : <Info size={14} />}
              </div>
              <div className="flex-1">
                <div className="flex justify-between items-start mb-1">
                  <p className={`text-sm font-bold ${!n.read ? 'text-slate-800' : 'text-slate-600'} group-hover:text-blue-600 transition-colors`}>
                    {n.title}
                  </p>
                  {!n.read && <div className="w-2 h-2 bg-blue-500 rounded-full shrink-0 mt-1.5"></div>}
                </div>
                <p className="text-xs text-slate-500 leading-relaxed mb-2">{n.text}</p>
                <p className="text-[10px] text-slate-400 font-medium">{n.date}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NotificationCenter;
